import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import {Observable, of} from 'rxjs';
import {UserConsentsService} from '../../user-consents.service';
import {MatDialog} from '@angular/material/dialog';
import {catchError, map, switchMap} from 'rxjs/operators';
import {UserConsentsDialogComponent} from '../../../user-consents-dialog/user-consents-dialog.component';
import {UserConsentsDialogData} from '../../../../models/user-consents/user-consents-dialog-data';

@Injectable({
  providedIn: 'root'
})
export class UserConsentsCanActivateGuard implements CanActivate {
  constructor(
    private userConsentsService: UserConsentsService,
    private dialog: MatDialog,
  ) {}

  canActivate(): Observable<boolean> {
    return this.userConsentsService.getStatus().pipe(
      switchMap(status => {
        if (status.privacy && status.terms) {
          return of(true);
        }
        const dialogRef = this.dialog.open<
          UserConsentsDialogComponent,
          UserConsentsDialogData,
          boolean
        >(UserConsentsDialogComponent, {
          disableClose: true,
          autoFocus: false,
          data: {
            needsPrivacy: !status.privacy,
            needsTerms: !status.terms
          }
        });
        return dialogRef.afterClosed().pipe(map(result => !!result));
      } ),
      catchError(() => of(true))
    );
  }
}
